module.exports = "/public/images/954b2812c98f2a4f5f37ca4b67012fe0.png";